<div class="app-main__inner">
  <div class="app-page-title">
    <div class="page-title-wrapper">
      <div class="page-title-heading">
        <div class="page-title-icon">
          <i class="pe-7s-file icon-gradient bg-mean-fruit"></i>
        </div>
        <div>
          Document Type Master
          <div class="page-title-subheading">Manage document types used when uploading employee documents.</div>
        </div>
      </div>
    </div>
  </div>

  <div class="mb-3 card">
    <div class="card-body">
      <div class="d-flex justify-content-end mb-3">
        <button type="button" class="btn btn-primary" (click)="openAddModal()">
          <i class="fa fa-plus me-1"></i> Add Document Type
        </button>
      </div>

      <div *ngIf="errorMessage" class="alert alert-danger" role="alert">{{ errorMessage }}</div>

      <div *ngIf="isLoading" class="text-center text-muted py-4">Loading...</div>

      <div *ngIf="!isLoading && !records.length && !errorMessage" class="text-center text-muted py-4">
        No entries yet.
      </div>

      <vio-table-v2
        *ngIf="!isLoading && records.length"
        [tableData]="records"
        [tableConfig]="tableConfig"
      ></vio-table-v2>
    </div>
  </div>
</div>

<!-- Add / Edit Modal -->
<div
  class="modal fade"
  id="addDocumentTypeMasterModal"
  tabindex="-1"
  aria-labelledby="addDocumentTypeMasterModalLabel"
  aria-hidden="true"
  #addModal
>
  <div class="modal-dialog">
    <div class="modal-content">
      <form (ngSubmit)="saveRecord()" #docTypeForm="ngForm">
        <div class="modal-header">
          <h5 class="modal-title" id="addDocumentTypeMasterModalLabel">
            {{ editingId ? 'Edit Document Type' : 'Add Document Type' }}
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div *ngIf="errorMessage" class="alert alert-danger" role="alert">{{ errorMessage }}</div>

          <div class="mb-3">
            <label class="form-label" for="docName">Document Name <span class="text-danger">*</span></label>
            <input
              id="docName"
              type="text"
              class="form-control"
              name="documentName"
              [(ngModel)]="documentName"
              required
            />
          </div>

          <div class="mb-3">
            <label class="form-label" for="docPeriod">Document Period <span class="text-danger">*</span></label>
            <select
              id="docPeriod"
              class="form-select"
              name="documentPeriod"
              [(ngModel)]="documentPeriod"
              required
            >
              <option value="" disabled>Select period</option>
              <option *ngFor="let p of periodOptions" [value]="p">{{ p }}</option>
            </select>
          </div>

          <div class="mb-3">
            <label class="form-label" for="docType">Document Frequency <span class="text-danger">*</span></label>
            <select
              id="docType"
              class="form-select"
              name="documentFrequency"
              [(ngModel)]="documentFrequency"
              (ngModelChange)="onDocumentFrequencyChange()"
              required
            >
              <option value="" disabled>Select type</option>
              <option *ngFor="let t of typeOptions" [value]="t">{{ t }}</option>
            </select>
          </div>

          <div class="mb-3" *ngIf="documentFrequency === 'Conditional Access'">
            <label class="form-label">
              Authorized Employees <span class="text-danger">*</span>
            </label>
            <div class="d-flex align-items-center gap-2 mb-2">
              <button type="button" class="btn btn-outline-primary btn-sm" (click)="openEmpPicker()">
                <i class="fa fa-users me-1"></i>
                {{ selectedEmpNos.length > 0 ? 'Change Selection' : 'Select Employees' }}
              </button>
              <span *ngIf="selectedEmpNos.length > 0" class="badge bg-primary">
                {{ selectedEmpNos.length }} selected
              </span>
            </div>
            <div *ngIf="selectedEmpNos.length > 0" class="border rounded p-2" style="min-height: 40px;">
              <span
                *ngFor="let emp of selectedEmployeeDetails"
                class="badge bg-light text-dark border me-1 mb-1 d-inline-flex align-items-center gap-1"
                style="font-size: 0.82rem;"
              >
                {{ emp?.name }} <span class="text-muted">({{ emp?.empNo }})</span>
                <button
                  type="button"
                  class="btn-close btn-close-sm ms-1"
                  style="font-size: 0.6rem;"
                  aria-label="Remove"
                  (click)="removeSelectedEmp(emp?.empNo || '')"
                ></button>
              </span>
            </div>
            <div *ngIf="selectedEmpNos.length === 0" class="form-text text-danger">
              At least one employee must be selected.
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button type="submit" class="btn btn-primary" [disabled]="!docTypeForm.form.valid || isSaving">
            {{ isSaving ? (editingId ? 'Updating...' : 'Saving...') : (editingId ? 'Update' : 'Save') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Employee Picker Modal -->
<div
  class="modal fade"
  id="empPickerModal"
  tabindex="-1"
  aria-labelledby="empPickerModalLabel"
  aria-hidden="true"
  #empPickerModal
>
  <div class="modal-dialog modal-xl modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="empPickerModalLabel">
          Select Authorized Employees
          <span *ngIf="tempSelectedEmpNos.length > 0" class="ms-2 badge bg-primary">
            {{ tempSelectedEmpNos.length }} selected
          </span>
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body p-0">
        <!-- Bulk action toolbar -->
        <div class="p-3 border-bottom d-flex gap-2">
          <button type="button" class="btn btn-outline-secondary btn-sm" (click)="selectAllVisible()">
            Select All
          </button>
          <button type="button" class="btn btn-outline-secondary btn-sm" (click)="clearAllVisible()">
            Clear All
          </button>
        </div>

        <!-- Employee table -->
        <div class="p-3">
          <vio-table-v2
            #empPickerTable
            [tableData]="employees"
            [tableConfig]="empPickerTableConfig"
            (selectionChange)="onEmpSelectionChange($event)"
          ></vio-table-v2>
        </div>
      </div>
      <div class="modal-footer">
        <span class="me-auto text-muted small">
          {{ tempSelectedEmpNos.length }} employee(s) selected
        </span>
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="confirmEmpSelection()">
          Confirm Selection
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Delete Confirmation Modal -->
<div
  class="modal fade"
  id="deleteDocumentTypeMasterModal"
  tabindex="-1"
  aria-labelledby="deleteDocumentTypeMasterModalLabel"
  aria-hidden="true"
  #deleteModal
>
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteDocumentTypeMasterModalLabel">Confirm Delete</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        Are you sure you want to delete <strong>{{ deletingName }}</strong>?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-danger" (click)="confirmDelete()" [disabled]="isDeleting">
          {{ isDeleting ? 'Deleting...' : 'Delete' }}
        </button>
      </div>
    </div>
  </div>
</div>
